<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
  >
    <div
      class="pop"
      data-sensors-exposure-property-caseId="SignOut"
      data-sensors-exposure-property-msg_name="无额度挽留弹窗"
      data-sensors-exposure-event-name="PopupDisplay"
    >
      <img src="./images/img_signout_noAmount_top@2x.png" >
      <div class="content">
        您即将获得<span class="amount">{{ amountLimit }}</span>元
        <br />
        真的要注销吗？
      </div>
      <div class="actions">
        <nd-button @click="backHome">立即申请借款</nd-button>
        <div class="signout" @click="showRiskNoticePage" data-sensors-click>继续注销</div>
      </div>
      <div class="percnet-bubble">95%通过率</div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    amountLimit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    showRiskNoticePage () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

/deep/.nd-dialog-content {
  .default-content {
    padding-top: 0;
  }
}
.pop {
  text-align: center;
  .content {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    margin-top: 45px;
    .amount {
      color: #FF4633;
    }
  }
  .actions {
    .nd-button {
      width: 380px;
      height: 80px;
      margin: 36px auto 0;
    }
    .signout {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      margin: 23px auto 30px;
    }
  }
  .percnet-bubble {
    position: absolute;
    bottom: 154px;
    right: 124px;
    width: 124px;
    height: 40px;
    background: rgba(0,0,0,0.8);
    border-radius: 20px 20px 20px 0px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
  }
}
</style>